module.exports = __webpack_public_path__ + "img/phone-solid.c975782e.svg";